import { Logger } from '@mntn-dev/logger'

export const realtimeUpdateLogger = Logger('realtime')
